import {
  MODEL_ID,
  PROVIDER,
  ACTION,
  MODE,
  MATERIAL,
  GENERATE_TYPE,
  POLYGON_TYPE,
  MODEL_FORMAT_OUTPUT,
  VIEW_TYPE,
} from 'Pods/ThreeDStudio/Store/constants'

export default {
  "model_id": MODEL_ID.TENCENT_IMAGE_TO_3D_PRO,
  "provider": PROVIDER.TENCENT,
  "action": ACTION.IMAGE_TO_3D,
  "mode": MODE.NORMAL,
  "input_schema": {
    "type": "object",
    "properties": {
      "input_image": {
        "type": "string",
        "allowedTypes": ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
        "maxFileSize": 100 * 1024 * 1024,
        // Multi-view limits from cgt-ai-studio-schema: accepted labelled views in the
        // provider's order, and how many images a multi-view run may carry.
        "multiView": {
          "viewTypes": [
            VIEW_TYPE.FRONT,
            VIEW_TYPE.LEFT,
            VIEW_TYPE.RIGHT,
            VIEW_TYPE.BACK,
            VIEW_TYPE.TOP,
            VIEW_TYPE.BOTTOM,
            VIEW_TYPE.LEFT_FRONT,
            VIEW_TYPE.RIGHT_FRONT,
          ],
          "minItems": 2,
          "requiredViews": [VIEW_TYPE.FRONT, VIEW_TYPE.BACK],
          "maxItems": 8,
        },
      },
      "multiview_input": {
        "type": "boolean",
      },
      "material": {
        "type": "string",
        "enum": [MATERIAL.GEOMETRY_ONLY, MATERIAL.BASIC, MATERIAL.PBR],
        "default": MATERIAL.BASIC,
      },
      "face_count": {
        "type": "integer",
        "minimum": 10000,
        "maximum": 1000000,
        "default": 750000,
      },
      "polygon_type": {
        "type": "string",
        "enum": [POLYGON_TYPE.TRIANGLE, POLYGON_TYPE.QUADRILATERAL],
        "default": POLYGON_TYPE.TRIANGLE,
      },
    },
    "required": ["input_image"],
    "allOf": [
      {
        "if": {
          "properties": {
            "material": { "enum": [MATERIAL.BASIC, MATERIAL.GEOMETRY_ONLY, MATERIAL.PBR] },
          },
          "required": ["material"],
        },
        "then": false,
      },
      {
        "required": ["input_image"],
      },
      {
        "if": {
          "properties": { "material": { "const": MATERIAL.GEOMETRY_ONLY } },
          "required": ["material"],
        },
        "then": {
          "properties": {
            "material_mode": { "const": 'none' },
          },
        },
      },
      {
        "if": {
          "properties": { "material": { "const": MATERIAL.BASIC } },
          "required": ["material"],
        },
        "then": {
          "properties": {
            "material_mode": { "const": 'shaded' },
          },
        },
      },
      {
        "if": {
          "properties": { "material": { "const": MATERIAL.PBR } },
          "required": ["material"],
        },
        "then": {
          "properties": {
            "material_mode": { "const": 'PBR' },
          },
        },
      },
      {
        "if": {
          "properties": { "polygon_type": { "const": POLYGON_TYPE.TRIANGLE } },
          "required": ["polygon_type"],
        },
        "then": {
          "properties": {
            "model": { "const": '3.1' },
            "generate_type": { "const": GENERATE_TYPE.NORMAL },
            "model_format_output": { "const": MODEL_FORMAT_OUTPUT.GLB },
          },
        },
      },
    ],
  },
  "ui_schema": {},
  "active_if": {
    "properties": {
      "smart_low_poly": { "const": false },
      "ultra_mode": { "const": false },
      "polygon_type": { "const": POLYGON_TYPE.TRIANGLE },
    },
  },
}
